export const QUERY_KEYS = {
    SIGNUP_REQUESTS: 'signup-requests',
    ADMIN_CONFIG: 'adminConfig'
} as const

export const MUTATION_KEYS = {
    SWITCH_AUTO_APPROVE: 'switchAutoApprove',
    UPDATE_CREDITS: 'updateCredits'
}
